import React from 'react';
import { RatingOverlay } from '.';

interface IKidsRatingOverlayProps {
	ratingItemId: string;
	ratingItemTitle?: string;
	returnUrl?: string;
	isEmbedded?: boolean;
	hideRating: () => void;
}

export class KidsRatingOverlay extends React.Component<IKidsRatingOverlayProps> {
	render() {
		const { ratingItemId, ratingItemTitle, returnUrl, isEmbedded, hideRating } = this.props;

		return (
			<RatingOverlay
				ratingItemId={ratingItemId}
				ratingItemTitle={ratingItemTitle}
				returnUrl={returnUrl}
				isEmbedded={isEmbedded}
				hideRating={hideRating}
				isKidsMode
			/>
		);
	}
}
